
export { logger } from "/app/libs/core/src/application-insights.ts"